<template>
  <div class="vz-order-total-price-get-btn" @mousedown.stop @touchstart.stop @touchend.stop>
    <div v-if="!locked" class="vz-order-total-price-get-btn--main">
      <vz-button
        big
        variant="primary"
        @click="emit('send-form')"
      >
        {{ sendTitle }}
      </vz-button>
      <vz-button
        big
        @click="emit('get-price')"
      >
        Пересчитать
      </vz-button>
    </div>
    <vz-button
      v-if="multiOrder.selectedRequestId && !hideNext"
      variant="primary"
      big
      outline
      icon-name="arrow-right"
      icon-right
      class="mt-20 w-100 flex flex-center flex-wrap"
      @click="back"
    >
      Вернуться к мультизаявке
    </vz-button>
    <template v-if="locked">
      <vz-button
        variant="primary"
        big
        outline
        icon-name="arrow-left"
        class="mt-20 w-100 flex flex-center flex-wrap"
        :to="{ name: 'personal-orders-tab' }"
      >
        К списку заказов
      </vz-button>
      <vz-button
        variant="primary"
        big
        outline
        class="mt-20 w-100 flex flex-center"
        @click="clear"
      >
        Новый мультизаказ
      </vz-button>
      <vz-button
        v-if="multiOrder.multiPickupRoute"
        variant="primary"
        big
        class="mt-10 w-100 flex flex-center flex-wrap"
        :to="multiOrder.multiPickupRoute"
      >
        Групповой забор
      </vz-button>
    </template>
  </div>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';
import {useUserStore} from '~/stores/personal/user';
import VzButton from '~/components/ui-kit/vz-button.vue';
import {LAST_ORDER_DRAFT_KEY} from '~/types/order/order';

const emit = defineEmits(['send-form', 'get-price'])

const props = defineProps({
  hideNext: {
    type: Boolean,
    default: false
  }
})

const {$confirm} = useNuxtApp()
const { orderForm } = storeToRefs(useOrderStore())
const { multiOrder } = useOrderStore()
const { isAuth } = storeToRefs(useUserStore())

const sendTitle = computed(() => {
  return multiOrder.selectedRequestId ? 'Сохранить' : 'Оформить'
})

const locked = computed(() => {
  return multiOrder.locked && !multiOrder.selectedRequestId
})

function clear() {
  multiOrder.requestList = []
  multiOrder.editMultiOrderMode = true
  sessionStorage.removeItem(LAST_ORDER_DRAFT_KEY)
}

async function back() {
  const exit = JSON.stringify(multiOrder.selectedRequest) === JSON.stringify(orderForm.value)
    ? true
    : await $confirm({
      buttonText: 'Выйти',
      cancelText: 'Отменить',
      title: 'Выйти без сохранения?',
      text: 'При переходе к мультизаявке текущие данные по доставке в текущий адрес не сохранятся'
    })
  if (exit) {
    multiOrder.getFromStorage()
    multiOrder.selectedRequestId = 0
  }
}
</script>

<style lang="scss" scoped>
</style>
